import { Box, Tab, Tabs } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import SectionHeader from "../../../util/component/SectionHeader";
import { STATE_ACTIVE_TAB, STATE_DISABLE_TAB } from "./enelx/constants/EnelxRecoil";
import Recharges from "./enelx/sections/Recharges";
import Reports from "./enelx/sections/Reports";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ReportPreview from "./enelx/sections/ReportPreview";
import { useHasScope } from "../../../config/globalConfig";
import {ENELX_VIEW_CONFIGURATION, ENELX_VIEW_HISTORY, ENELX_VIEW_REPORTS} from "../utils/FinanceScope";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import Configuration from "./enelx/sections/Configuration";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

const PageEnelX = (props: any) => {
    const hasScope = useHasScope;
    const { t } = useTranslation('finance', { keyPrefix: 'enelx' });
    const [activeTab, setActiveTab] = useRecoilState(STATE_ACTIVE_TAB);

    const [disableTab, setDisableTab] = useRecoilState(STATE_DISABLE_TAB);
    const navigate = useNavigate();
    const location = useLocation();
    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const tabReport = hasScope(ENELX_VIEW_REPORTS);
    const tabRecharge = hasScope(ENELX_VIEW_HISTORY);
    const tabConfiguration = hasScope(ENELX_VIEW_CONFIGURATION);
    const changeTabAndPath = (newValue: any) => {
        setActiveTab(newValue);
        if(newValue && newValue == 1){
            navigate('/finance/enel-x/recharge');
        } else if(newValue && newValue == 2){
            navigate('/finance/enel-x/configuration');
        } else {
            navigate('/finance/enel-x');
        }
    }

    useEffect(() => {
        if (location.pathname === "/finance/enel-x" || location.pathname === "/finance/enel-x/report") {
       
            if (!tabReport && tabRecharge){
                setActiveTab(1); 
                navigate("/finance/enel-x/recharge");
            } else {
                setActiveTab(0); 
                navigate("/finance/enel-x/");
            }

        } else if (location.pathname === "/finance/enel-x/recharge") {
            setActiveTab(1);
        } else if (location.pathname === "/finance/enel-x/configuration") {
            setActiveTab(2);
            navigate("/finance/enel-x/configuration/");
        }
    })

    if (!hasScope(ENELX_VIEW_REPORTS) && !hasScope(ENELX_VIEW_HISTORY)) return (<NotAuthorizedDialog/>);

    return (
        <Box>
            <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')} />
            {!disableTab &&

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={(_event, newValue: number) => changeTabAndPath(newValue)}>
                        {hasScope(ENELX_VIEW_REPORTS) &&
                            <Tab label={t('tabs.report')} {...a11yProps(0)} />
                        }
                        {hasScope(ENELX_VIEW_HISTORY) &&
                            <Tab label={t('tabs.recharges')} {...a11yProps(1)} />
                        }
                        {hasScope(ENELX_VIEW_CONFIGURATION) &&
                            <Tab label={t('tabs.configuration')} {...a11yProps(2)} />
                        }
                    </Tabs>
                </Box>

            }
            {hasScope(ENELX_VIEW_REPORTS) &&
                <TabPanel value={activeTab} index={0}>
                    <Routes>
                        <Route path="/" element={
                            <Reports />
                        }>
                        </Route>
                        <Route path="/report/:id" element={
                            <ReportPreview />
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            }
            {hasScope(ENELX_VIEW_HISTORY) &&
                <TabPanel value={activeTab} index={1}>
                    <Routes>
                        <Route path="/recharge" element={
                            <Recharges />
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            }
            {hasScope(ENELX_VIEW_CONFIGURATION) &&
                <TabPanel value={activeTab} index={2}>
                    <Routes>
                        <Route path="/configuration" element={
                            <Configuration />
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            }
        </Box>
    );
}

export default PageEnelX;